var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobdetailsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#D2F34C",
    stroke: "#244034"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9482 29C55.0341 29 55.1183 29.0072 55.2003 29.0211L55.474 29.0228C55.882 29.0228 56.272 29.1888 56.556 29.4828L66.686 40.0368C66.954 40.3148 67.1042 40.6888 67.1042 41.0748V59.4068C67.14 64.4248 63.232 68.5248 58.206 68.7288L42.168 68.7308H41.95C37.0501 68.6201 33.1203 64.6572 33.0006 59.8052L33 37.9808C33.116 33.0188 37.214 29.0228 42.14 29.0228L54.6961 29.0211C54.7781 29.0072 54.8623 29 54.9482 29ZM53.448 32.022L42.144 32.0228C38.83 32.0228 36.078 34.7068 36 38.0168V59.4068C35.926 62.8328 38.626 65.6548 42.018 65.7308H58.146C61.484 65.5928 64.128 62.8188 64.1042 59.4188L64.104 42.966L60.0842 42.968C56.4242 42.958 53.4482 39.974 53.4482 36.318L53.448 32.022ZM54.5746 54.2162C55.4026 54.2162 56.0746 54.8882 56.0746 55.7162C56.0746 56.5442 55.4026 57.2162 54.5746 57.2162H43.7746C42.9466 57.2162 42.2746 56.5442 42.2746 55.7162C42.2746 54.8882 42.9466 54.2162 43.7746 54.2162H54.5746ZM50.4848 46.7122C51.3128 46.7122 51.9848 47.3842 51.9848 48.2122C51.9848 49.0402 51.3128 49.7122 50.4848 49.7122H43.7728C42.9448 49.7122 42.2728 49.0402 42.2728 48.2122C42.2728 47.3842 42.9448 46.7122 43.7728 46.7122H50.4848ZM56.448 33.704L56.4482 36.318C56.4482 38.326 58.0822 39.962 60.0882 39.968L62.46 39.966L56.448 33.704Z",
    fill: "#244034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobdetailsicon);
export default __webpack_public_path__ + "static/media/jobdetailsicon.2d136ae28ccf420bd9bb817fd85d2a54.svg";
export { ForwardRef as ReactComponent };